import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

import { reviewArrayFieldStyles as sx } from '../ReviewArrayField.styles';

type Props = {
	title: ReactNode;
	rows: (ReactNode | null)[];
};

export const ReviewArrayCard = ({ title, rows }: Props) => {
	return (
		<Box sx={sx.nestedGroup}>
			<Typography
				component={'div'}
				dir='auto'
				aria-label='Review Array Card Title'
				sx={sx.nestedGroupTitle(rows.length > 0)}
			>
				{title}
			</Typography>
			{rows.length > 0 && <Divider sx={sx.divider} />}
			{rows.length > 0 ? <Box sx={sx.rowContainer}>{rows}</Box> : null}
		</Box>
	);
};
